import { render, staticRenderFns } from "./EspelhoAtendimento.vue?vue&type=template&id=0213365a&"
import script from "./EspelhoAtendimento.vue?vue&type=script&lang=js&"
export * from "./EspelhoAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports